// DESIGN.md §8.1.1 "Frontend half — Recovery (T-19)": the reaction to 403 `csrf_token_invalid`,
// exported so every slice reaches for the same one — "show the API's `message` with a link to
// the right sign-in door" (CR-007 §4.6). Whichever door it links to renders and completes a
// sign-in even while a stale or planted session cookie is present (neither door's page
// special-cases an existing cookie).
'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
// Relative, not `@/` — `frontend/vitest.config.ts` (T-03's, frozen) has no path-alias resolution.
import { NoticeBand } from '../../../components/ui/NoticeBand';
import { getApiError, isCsrfTokenInvalid } from '../errors';
import { signInPathFor } from '../doors';

const FALLBACK_MESSAGE = 'Permintaan ini tidak dapat diverifikasi. Masuk kembali untuk melanjutkan.';

export { isCsrfTokenInvalid };

/**
 * Renders the API's own `message` (DESIGN.md §9.1: Indonesian, already safe to render) with a
 * link back to the sign-in door that matches the page it is rendered on — `signInPathFor`
 * (CR-007 §4.6), never a literal `/masuk`. Callers should render this in place of their usual
 * error notice whenever `isCsrfTokenInvalid(error)` is true, on any unsafe request from anywhere
 * in the app.
 */
export function CsrfRecoveryNotice({ error }: { error: unknown }) {
  const pathname = usePathname();
  const message = getApiError(error)?.message ?? FALLBACK_MESSAGE;
  return (
    <NoticeBand tone="attention" title="Masuk kembali">
      <p>
        {message}{' '}
        <Link href={signInPathFor(pathname ?? '/')} className="underline underline-offset-2">
          Ke halaman masuk
        </Link>
        .
      </p>
    </NoticeBand>
  );
}
